export default "__VITE_ASSET__VmKofNPw__"